var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxErrorAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1320 1320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605 385H715V770H605V385ZM605 825H715V935H605V825Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.89 401.115L918.885 126.115C913.786 120.998 907.726 116.939 901.052 114.174C894.379 111.408 887.224 109.99 880 110H440C432.776 109.99 425.622 111.408 418.948 114.174C412.274 116.939 406.214 120.998 401.115 126.115L126.115 401.115C120.998 406.214 116.939 412.274 114.174 418.948C111.408 425.622 109.99 432.776 110 440V880C110 894.63 115.775 908.6 126.115 918.885L401.115 1193.89C406.214 1199 412.274 1203.06 418.948 1205.83C425.622 1208.59 432.776 1210.01 440 1210H880C894.63 1210 908.6 1204.23 918.885 1193.89L1193.89 918.885C1199 913.786 1203.06 907.726 1205.83 901.052C1208.59 894.379 1210.01 887.224 1210 880V440C1210.01 432.776 1208.59 425.622 1205.83 418.948C1203.06 412.274 1199 406.214 1193.89 401.115ZM1100 857.23L857.23 1100H462.77L220 857.23V462.77L462.77 220H857.23L1100 462.77V857.23Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxErrorAlt);
export default __webpack_public_path__ + "static/media/bx_error-alt.05c9cfe4.svg";
export { ForwardRef as ReactComponent };